export enum TipoRelacion {
    Habitual = '1',
    NoHabitual = '2'
}

export enum TipoPersona {
    Natural = '1',
    Juridica = '2'
}

export enum Acciones {
    NEW = 'N',
    EDIT = 'E',
    VIEW = 'V',
    DELETE = 'D'
}
export enum Formularios {
    operaciones = 'gestionSubasta',
}

export enum Modulo {
    HONRAMIENTO = "HON",
    SIMULADOR_HONRAMIENTO = "SIMHON",
}


export enum TamanioEmpresaProduce {
    MIQ = "MIQ",
    PEQ = "PEQ",
    MED = "MED"
}


export enum TamanioEmpresaSBS {
    MIQ = "MIQ",
    PEQ = "PEQ",
    MED = "MED"
}

export enum TamanioEmpresa {
    codigoTamanioEmpresaProduce = "1",
    codigoTamanioEmpresaSBS = "2"
}


export enum TypeAlert {
    Confirm = "confirm",
    ConfirmStep = "confirmstep",
    Info = "info",
    Error = "error",
    Success = "success",
    Validation = "validation",
    Aceptar = "aceptar"
}

export enum TipoAccionVisorPdf {
    PROCESAR = "PROC",
    RECHAZAR = "RECH"
}



export class CamposSolicitudCredito {
    codigoCampoSubasta: string;
    codigoCampoOrigenFondo: string;

    constructor() {
        this.codigoCampoSubasta = "10";
        this.codigoCampoOrigenFondo = "9";
    }
}

export class ClaseProducto {
    codigoIntermediacionCobertura: string;

    constructor() {
        this.codigoIntermediacionCobertura = "4";
    }
}

export class TasaCredito {
    codigoMenorIgual: string;
    codigoMayor: string;
    codigoMayorIgual: string;

    constructor() {
        this.codigoMenorIgual = "1";
        this.codigoMayor = "2";
        this.codigoMayorIgual = "3";
    }
}

export class Moneda {
    codigoSoles: string;
    codigoDolares: string;

    constructor() {
        this.codigoSoles = "PEN";
        this.codigoDolares = "USD";
    }
}

export class TipoOperacion {
    codigoNueva: string;
    codigoReembolso: string;
    codigoReemplazoCartera: string;
    codigoRenovacion: string;

    constructor() {
        this.codigoNueva = "1";
        this.codigoReembolso = "2";
        this.codigoReemplazoCartera = "3";
        this.codigoRenovacion = "4";
    }
}

export class TipoOperacionSIMP {
    codigoNueva: string;
    codigoSimulador: string;

    constructor() {
        this.codigoNueva = "1";
        this.codigoSimulador = "2";
    }
}

export class TipoArchivo {
    codigoExcel: string;
    codigoTxt: string;

    constructor() {
        this.codigoExcel = "1";
        this.codigoTxt = "2";
    }
}

export enum TipoEditableAsociacionPagos {
    noEsEditable = 0,
    esEditable = 1
}

export enum TipoEstadosExpediente {
    enviado = 'ENVIADO',
    pendiente = 'PENDIENTE',
    observado = 'OBSERVADO'
}

export enum TiposEstadosExpedienteDocumento {
    conforme = 'con',
    pendiente = 'pen',
    observado = 'obs'
}

export enum TipoObservacionesExpDocumento {
    sinObservaciones = 0,
    conObservaciones = 1
}

export enum TipoAccionRectificacionVisorPdf {
    CONFIRMADO = "CON",
    OBSERVADOPORCOFIDE = "OXC"
}
